import React from 'react';
import { TabEventType } from './TabEventType';
var Tab = function (props) {
    var id = props.id, title = props.title, _a = props.href, href = _a === void 0 ? '#' : _a, _b = props.target, target = _b === void 0 ? '_self' : _b, _c = props.selected, selected = _c === void 0 ? false : _c, _d = props.disabled, disabled = _d === void 0 ? false : _d, _e = props.outerClass, outerClass = _e === void 0 ? 'nav-item' : _e, _f = props.innerClass, innerClass = _f === void 0 ? 'nav-link' : _f, _g = props.tabIndex, tabIndex = _g === void 0 ? undefined : _g, _h = props.posInSet, posInSet = _h === void 0 ? undefined : _h, _j = props.setSize, setSize = _j === void 0 ? undefined : _j, onSelectedTabChanged = props.onSelectedTabChanged;
    var getLinkClass = function () {
        var className = [];
        if (selected && !disabled)
            className.push('active');
        if (disabled)
            className.push('disabled');
        if (innerClass)
            className.push(innerClass);
        return className.join(' ');
    };
    return (React.createElement("li", { className: outerClass, role: "presentation" },
        React.createElement("a", { id: id ? id : title, role: "tab", className: getLinkClass(), title: title, href: href, target: target, tabIndex: disabled ? -1 : tabIndex, "aria-selected": selected && !disabled ? 'true' : 'false', "aria-disabled": disabled, "aria-setsize": setSize, "aria-posinset": posInSet, onClick: function (nativeEvent) {
                return onSelectedTabChanged === null || onSelectedTabChanged === void 0 ? void 0 : onSelectedTabChanged(TabEventType.Click, nativeEvent);
            } }, title)));
};
export default React.memo(Tab);
